import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {Router} from '@angular/router';
import {CmisService} from '../../../../modules/services/cmis/cmis.service';


@Component({
    selector: 'app-cmis-table',
    templateUrl: './cmis-table.component.html',
    styleUrls: ['./cmis-table.component.css']
})
export class CmisTableComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() list: any[];

    @Output() sort = new EventEmitter<any>();


    dataSource = new MatTableDataSource<any>();


    readColumns: String[] = [
        'lawClCd',
        'title1',
        'title2',
        'title3',
        'moderNm',
        'modDt',
        'hitCnt'

    ];

    displayedColumns = [

        'title1',
        'moderNm',
        'modDt',
        'hitCnt',
        'actions'];

    displayedColumnsAR = [
        'title2',
        'moderNm',
        'modDt',
        'hitCnt',
        'actions'];
    displayedColumnsen = [
        'titleEn',
        'moderNm',
        'modDt',
        'hitCnt',
        'actions'];

    constructor(
        private translate: AppTranslateService,
        private router: Router,
        private cmisService: CmisService,
    ) {


    }

    ngOnInit(): void {

        this.loadDataSource();

    }

    getlangue() {

        return this.translate.getDefaultLang() == 'ar';
    }

    getcol() {


        if (this.getlangue()) {
            return this.displayedColumnsAR;
        } else if (this.translate.getDefaultLang() == 'en') {
            return this.displayedColumnsen;
        } else {
            return this.displayedColumns;
        }
    }

    ngAfterViewInit(): void {

        this.loadDataSource();
    }

    loadDataSource() {
        this.dataSource.data = this.list;
    }

    ngOnChanges(changes: SimpleChanges): void {

        const {list} = changes;
        if (list.currentValue !== list.previousValue) {
            this.loadDataSource();
        }
    }

    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }


    openDetails(element) {
        const getUrl = (lawClCd) => {
            switch (lawClCd) {
                case 'A':
                    return '/portail/cmis_Lois/cmiscard_loi';
                case 'B':
                    return '/portail/cmis_Decrets/cmiscard_Decrets';
                case 'C':
                    return '/portail/cmis_Arretes/cmiscard_Arretes';
                case 'E':
                    return '/portail/cmis_manuel/cmiscard_Manuel';
                case 'Z':
                    return '/portail/cmis_Autres/cmiscard_Autres';
            }
        };


        this.cmisService.updateHitCnt(element.seqno)
            .subscribe(response => {
                this.router.navigate([getUrl(element.lawClCd), element.seqno]);
            });
    }


}
